
import { QueryResult } from '@apollo/client';
import {
  GetKonteringHistory,
  GetKonteringHistoryVariables,
  GetKonteringHistory_node_TEDLRLeverantor,
} from '../../Queries/_QueryTypes/GetKonteringHistory';
import EDButton from '../../../../../../../../../BaseComponents/Buttons/Button/EDButton';

interface IProps {
  fetchingMore: boolean;
  setFetchingMore: React.Dispatch<React.SetStateAction<boolean>>;
  query: QueryResult<GetKonteringHistory, GetKonteringHistoryVariables>;
  queryData: GetKonteringHistory_node_TEDLRLeverantor;
  supplierID: string;
}

const FetchMoreButton: React.FC<React.PropsWithChildren<IProps>> = props => {
  const numberOfEdges =
    props.queryData?._Associations?.Fakturor_Connection?.edges?.length ?? 0;

  const haveReachedLimit =
    numberOfEdges >=
      (props.queryData?._Associations?.Fakturor_Connection?.totalCount ?? 0) ||
    numberOfEdges >= 100;

  const onClick = (): void => {
    props.setFetchingMore(true);
    props.query
      .fetchMore({
        variables: {
          id: props.supplierID,
          lastID:
            props.queryData?._Associations?.Fakturor_Connection?.edges?.[
              props.queryData?._Associations?.Fakturor_Connection?.edges
                ?.length - 1
            ]?.cursor,
        },
      })
      .then(() => {
        props.setFetchingMore(false);
      });
  };
  return (
    <EDButton
      marginY={1}
      disabled={haveReachedLimit || props.fetchingMore || props.query.loading}
      disabledReason={
        props.fetchingMore || props.query.loading
          ? 'Hämtar fakturor'
          : 'Det finns ingen mer historik'
      }
      flat
      label="Hämta fler"
      onClick={onClick}
    />
  );
};

export default FetchMoreButton;
